module.exports = __webpack_public_path__ + "img/1531756450.21134fff.jpg";